import { formatEntityName, replaceEntityName } from "helpers";
import { useTranslations } from "providers";

import { ConfirmDialog, ConfirmDialogProps } from "./ConfirmDialog";

interface ConfirmDeleteProps extends Omit<ConfirmDialogProps, "title" | "content" | "accept" | "cancel"> {
  isOpen: boolean;
  entityName: string;
  title?: string;
  entityTitle?: string;
  content?: string;
  accept?: string;
  cancel?: string;
}

export const ConfirmDelete: React.FC<ConfirmDeleteProps> = ({
  entityName,
  entityTitle,
  title,
  content,
  cancel,
  accept,
  ...props
}) => {
  const i18n = useTranslations();
  const entityNameWithTitle = formatEntityName(entityName, entityTitle ?? i18n.EntityTitle_Unknown);

  title = title || i18n.Entity_Delete_ConfirmTitle;
  title = replaceEntityName(title, entityNameWithTitle);

  content = content || i18n.Entity_Delete_ConfirmContent;
  content = replaceEntityName(content, entityNameWithTitle);

  cancel = cancel || i18n.Confirm_Cancel;
  accept = accept || i18n.Confirm_Accept;

  return <ConfirmDialog {...props} accept={accept} cancel={cancel} title={title} content={content} />;
};
